<script>
import {Bar, mixins} from 'vue-chartjs';

export default {
    extends: Bar,
    name: 'bar-chart',
    props: ['chartData', 'options', 'chartId'],
    mixins: [mixins.reactiveProp],
    data() {
        return {
            isLoaded: false
        };
    },
    computed: {
        stepSize() {
            return this.options.scales.yAxes[0].ticks.stepSize;
        }
    },
    mounted() {
        // Overwriting base render method with actual data.
        this.renderChart(this.chartData, this.options);
        this.$eventHub.$on(this.chartId, () => {
            if (this.isLoaded) {
                this.$data._chart.destroy();
                this.renderChart(this.chartData, this.options);
            }
        });
        this.isLoaded = true;
    },
    watch: {
        stepSize() {
            this.$data._chart.options.scales.yAxes[0].ticks.stepSize = this.options.scales.yAxes[0].ticks.stepSize;
            this.$data._chart.update();
        }
    },
    beforeDestroy() {
        this.$eventHub.$off(this.chartId);
    }
};
</script>



// WEBPACK FOOTER //
// src/components/charts/BarChart.vue